"use client";

import { PlaceType } from "../../../generated/graphql";
import { useTourPageContext } from "../context";

export enum TourSectionId {
    OVERVIEW = "overview",
    ITINERARY = "itinerary",
    ACCOMMODATIONS = "accommodations",
    EQUIPMENT = "equipment",
    FLIGHTS = "flights",
    PHOTOS = "photos",
    REVIEWS = "reviews",
    FAQ = "faq",
    PRIMARY_MESSAGE = "primaryMessage",
    SECONDARY_MESSAGE = "secondaryMessage",
    TERTIARY_MESSAGE = "tertiaryMessage",
    WEATHER = "weather",
}

export const useTourPageSectionConfiguration = () => {
    const { tourContent, pageConfig, reviewAggregate } = useTourPageContext();

    const isSectionDisplayed = (section: TourSectionId) => {
        const faqs = tourContent.faq?.items;
        const cities = tourContent.tour?.places.filter(
            (place) => place.type === PlaceType.City,
        );

        switch (section) {
            case TourSectionId.OVERVIEW:
                return !!tourContent;
            case TourSectionId.ITINERARY:
                return tourContent.itineraryItems.length > 0;
            case TourSectionId.ACCOMMODATIONS:
                return !!tourContent.accommodations.length;
            case TourSectionId.EQUIPMENT:
                return !!tourContent.equipment?.length;
            case TourSectionId.FLIGHTS:
                return (
                    !!pageConfig.flightsDescription ||
                    !!(
                        pageConfig.flightsInclusionsHeading &&
                        pageConfig.flightsInclusions
                    )
                );
            case TourSectionId.PHOTOS:
                return true;
            case TourSectionId.REVIEWS:
                return !!reviewAggregate;
            case TourSectionId.FAQ:
                return !!faqs?.length;
            case TourSectionId.WEATHER:
                return !!cities?.length;
            default:
                return false;
        }
    };

    return {
        isSectionDisplayed,
    };
};
